import { useTranslationPlus } from '@/Core/i18n/useTranslationPlus';
import FromItemPlus from '@/components/FormItemPlus/FromItemPlus'
import React, { useEffect, useState } from 'react'
import WidthdrawWay from '../compoments/widthdrawWay/WidthdrawWay';
import { IFInitWalletRsp, IFInitWalletWithdrawFlatRsp, IFWithdrawFlatConfigRsp } from '@/api/apiRsp/IFWalletRsp';
import type { FormInstance } from '@/componentsUI/Form';
import InputUI from '@/componentsUI/Input';
import { isCPF, isEmail, isPIXFullName, isPhoneBX } from '@/Core/features/verification';
import './index.less'
import SelectUI, { SelectOption, type OptionInfo } from '@/componentsUI/Select';
import { AmountDivisorConversion, AmountMultiplierConversion, dealAmount0Fiexd } from '@/Core/utils/currencyDealCenter';
import InputWithdrawAmount from '@/components/WalletComp/InputWithdrawAmount';
import InputMaskPlus from '../compoments/inputMask/InputMask';
import WithdrawTaxNotice from '../../components/WithdrawTaxNotice';

interface SelectAccountTypeProps {
    prefixCls?: string;
    onChange?: (value: any, option: OptionInfo | OptionInfo[]) => void;
    options?: any[];
    value?: any;
}

const SelectAccountType = (props: SelectAccountTypeProps) => {
    const { onChange, options, value } = props;

    return (
        <SelectUI className={`select`} value={value} onChange={onChange}>
            {options?.map((item, i) => {
                return (
                    <SelectOption key={i} value={item}>
                        <span>{item}</span>
                    </SelectOption>
                );
            })}
        </SelectUI>
    );
};

const WidthdrawPix = (props: {
    data: IFWithdrawFlatConfigRsp,
    form: FormInstance<any, any, string | number | symbol>,
    formValidateRef?: any,
    currentWallet?: IFInitWalletRsp;
    widthdrawConfig: IFInitWalletWithdrawFlatRsp
}) => {

    const { data, form, formValidateRef, currentWallet, widthdrawConfig } = props;
    const { t } = useTranslationPlus();
    const getAccountHolder = () => {
        if (accountType === 'EMAIL') {
            return t('Wallet.PlaceHolderPIXEmail');
        } else if (accountType === 'PHONE') {
            return t('Wallet.PlaceHolderPIXPhone');
        } else if (accountType === 'CPF') {
            return t('Wallet.PlaceHolderCPF');
        }
    }
    const [feeAmount, setFeeAmount] = useState('0');
    const currentData = widthdrawConfig;
    //"CPF,EMAIL,PHONE"
    const [accountType, setAccountType] = useState('CPF');

    //校验账户用户名
    const validatorAccountName = (value, cb) => {
        if (!formValidateRef?.current) {
            return
        }
        if (!value) {
            return cb(t('Wallet.PIX Wrong name'));
        } else if (!isPIXFullName(value)) {
            return cb(t('Wallet.PIX Wrong name'));
        }
    };

    //校验cpf
    const validatorCPF = (value, cb) => {
        if (!formValidateRef?.current) {
            return
        }
        if (!value) {
            return cb(t('Wallet.PIX Wrong account'));
        } else if (!isCPF(value)) {
            return cb(t('Wallet.PIX Wrong account'));
        }
    };

    //校验账户类型
    const validatorAccount = (value, cb) => {
        if (!formValidateRef?.current) {
            return
        }
        const errorMap = {
            CPF: 'Wallet.PIX Wrong account',
            EMAIL: 'Wallet.PIX Wrong email',
            PHONE: 'Wallet.PIX Wrong phone',
        };
        let flag = true;
        if (accountType == 'CPF') {
            flag = isCPF(value ?? '');
        } else if (accountType == 'EMAIL') {
            flag = isEmail(value);
        } else if (accountType == 'PHONE') {
            flag = isPhoneBX(value);
        }
        if (!value) {
            return cb(t(errorMap[accountType]));
        } else if (!flag && value) {
            return cb(t(errorMap[accountType]));
        }
    };

    //金额校验
    const validatorAmount = (value, cb) => {
        if (!formValidateRef.current) {
            return
        }
        if (!value) {
            return cb(t('Wallet.Wrong Amount'));
        }
        if (!value) {
            return cb('');
        }
        const amount = AmountMultiplierConversion(value, {
            currencyType: currentWallet.currencyType,
        });
        if (
            !amount ||
            amount > currentWallet?.balance ||
            amount < Number(currentData?.singleMinimumCoin) ||
            amount > Number(currentData?.singleMaximumCoin) ||
            amount > Number(data?.availableAmount)
        ) {
            return cb(t('Wallet.Wrong Amount'));
        }
    };

    const refreshFree = (amount) => {
        const withdrawAmount = Number(amount);
        const { adminFee = 0, withdrawalCommission = 0 } = currentData || {};
        const fee = (
            Number(withdrawAmount) * (Number(withdrawalCommission) / 100) +
            AmountDivisorConversion(adminFee, {
                currencyType: currentWallet.currencyType,
            })
        ).toFixed(2);
        setFeeAmount(fee);
    }

    useEffect(()=>{
        form.setFieldValue('witdrawWay', {
            ...form.getFieldValue('witdrawWay'),
            accountType: 'CPF'
        });
    },[])

    return (
        <div className='widthdraw-pix'>
            {/* <FromItemPlus */}
            {/*     field={'accountName'} */}
            {/*     label={t('Wallet.AccountHolderName')} */}
            {/*     rules={[{ validator: validatorAccountName }]} */}
            {/* > */}
            {/*     <InputUI placeholder={t('Wallet.PlaceHolderPIXFullName')} maxLength={20} /> */}
            {/* </FromItemPlus> */}

            {/* <FromItemPlus */}
            {/*     field={'cpf'} */}
            {/*     label={t('Wallet.PIX_TYPE_CPF')} */}
            {/*     rules={[{ validator: validatorCPF }]} */}
            {/*     className={'cpf'} */}
            {/* > */}
            {/*     <InputMaskPlus className={'input-mask'} mask={'999.999.999-99'} placeholder={t('Wallet.PlaceHolderCPF')} /> */}
            {/* </FromItemPlus> */}

            {/* {<FromItemPlus
                field={'account'}
                className={'cpf'}
                label={
                    <div className={`account-type`}>
                        <div className={`account-type-title`}>{t('Wallet.AccountType')}</div>

                        <SelectAccountType options={['CPF','EMAIL','PHONE']} onChange={(v) => {
                            setAccountType(v)
                            form.setFieldValue('witdrawWay', {
                                ...form.getFieldValue('witdrawWay'),
                                accountType: v
                            });
                            form.setFieldValue('account', '');
                        }} value={accountType} />
                    </div>
                }
                rules={[{ validator: validatorAccount }]}
            >
                {
                    accountType === 'CPF' ?
                        <InputMaskPlus className={'input-mask'} mask={'999.999.999-99'} placeholder={t('Wallet.PlaceHolderCPF')} /> :
                        <InputUI
                            placeholder={getAccountHolder()}
                            prefix={accountType === 'PHONE' && <span className="text"> {'+55'}</span>}
                            maxLength={accountType === 'EMAIL' ? 50 : 11}
                        />
                }

            </FromItemPlus>} */}



            <FromItemPlus
                field={'amount'}
                label={
                    <div className={`title`}>
                        <span> {t('Wallet.WithdrawAmountTitle') + `(${dealAmount0Fiexd(currentData?.singleMinimumCoin, {
                            currencyType: currentWallet?.currencyType,
                        }) + '-' +
                            dealAmount0Fiexd(currentData?.singleMaximumCoin, {
                                currencyType: currentWallet?.currencyType,
                            })
                            })`} </span>
                    </div>
                }
                rules={[{ validator: validatorAmount }]}
                className={`amount`}
            >
                <InputWithdrawAmount
                    availableAmount = {dealAmount0Fiexd(data.availableAmount, {
                        currencyType: currentWallet?.currencyType
                    })}
                    lockAmount = {
                        dealAmount0Fiexd(data.lockAmount, {
                            currencyType: currentWallet?.currencyType
                        })
                    }
                    balance={AmountDivisorConversion(currentWallet?.balance, {
                        currencyType: currentWallet?.currencyType,
                    })}
                    min={AmountDivisorConversion(currentData?.singleMinimumCoin, {
                        currencyType: currentWallet?.currencyType,
                    })}
                    max={AmountDivisorConversion(currentData?.singleMaximumCoin, {
                        currencyType: currentWallet?.currencyType,
                    })}
                    onChange={(v) => {
                        refreshFree(v);
                    }}
                />
            </FromItemPlus>

            <div className={`fee`}>
                <WithdrawTaxNotice
                    rate={currentData?.withdrawalCommission}
                    amount={feeAmount}
                />
            </div>

        </div>
    )
}

export default WidthdrawPix
